document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".pb-builder").forEach((root) => {
    if (root.dataset.inited) return;
    root.dataset.inited = "1";

    const STYLE_PRICES = {
      "2d": { pair: 24.99, single: 12.99 },
      "3dgel": { pair: 30.99, single: 16.99 },
      "4dgloss": { pair: 30.99, single: 16.99 },
      "4dmatte": { pair: 39.99, single: 20.99 },
      "4d6mmgloss": { pair: 39.99, single: 21.99 },
      "5dgel": { pair: 45.99, single: 23.99 },
      "shadow": { pair: 53.99, single: 27.99 },
      "ghost": { pair: 53.99, single: 27.99 },
      "bevelled": { pair: 64.99, single: 33.99 },
      "mattebevelled": { pair: 64.99, single: 33.99 }
    };

    const reg = root.querySelector("[data-reg]");
    const style = root.querySelector("[data-style]");
    const price = root.querySelector("[data-price]");
    const status = root.querySelector("[data-status]");
    const addBtn = root.querySelector("[data-add]");
    const evBtn = root.querySelector("[data-ev]");
    const front = root.querySelector("[data-frontplate]");
    const rear = root.querySelector("[data-rearplate]");
    const ft = root.querySelector("[data-fronttext]");
    const rt = root.querySelector("[data-reartext]");

    let plates = "both";
    let ev = false;

    function gbp(n){ return "£" + n.toFixed(2); }

    function update(){
      const raw = reg.value.toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,8);
      ft.textContent = raw || "YOUR REG";
      rt.textContent = raw || "YOUR REG";

      front.classList.toggle("hidden", plates === "rear");
      rear.classList.toggle("hidden", plates === "front");

      front.classList.toggle("ev-on", ev);
      rear.classList.toggle("ev-on", ev);

      const p = STYLE_PRICES[style.value];
      const val = plates === "both" ? p.pair : p.single;
      price.textContent = gbp(val);
      addBtn.textContent = "Add to Basket — " + gbp(val);
    }

    root.querySelectorAll("[data-plates]").forEach(b=>{
      b.onclick = ()=>{
        plates = b.dataset.plates;
        root.querySelectorAll("[data-plates]").forEach(x=>x.classList.remove("active"));
        b.classList.add("active");
        update();
      };
    });

    evBtn.onclick = ()=>{
      ev = !ev;
      evBtn.textContent = ev ? "EV Green Strip: ON" : "EV Green Strip: OFF";
      evBtn.classList.toggle("active", ev);
      update();
    };

    reg.oninput = update;
    style.onchange = update;

    status.textContent = "Builder loaded ✅";
    update();
  });

});